import type { Dict } from './en';

/** Russian. */
const ru: Dict = {
  languageName: 'Русский',

  nav: {
    products: 'Продукты',
    team: 'Команда',
    about: 'О нас',
    contact: 'Контакты',
  },

  hero: {
    eyebrow: 'Vaqtly Holding',
    headlinePre: 'Мы создаём ',
    headlineAccent: 'продукты',
    headlinePost: ', которыми пользуются каждый день.',
    body:
      'Vaqtly — холдинг, создающий цифровые продукты в Узбекистане. Сегодня работают два ' +
      'наших стартапа.',
    ctaPrimary: 'Наши продукты',
    ctaSecondary: 'Связаться',
  },

  products: {
    eyebrow: 'Продукты',
    heading: 'Стартапы Vaqtly',
    visit: 'Перейти на сайт',
    status: {
      live: 'Работает',
      beta: 'Бета',
      soon: 'Скоро',
    },
  },

  team: {
    eyebrow: 'Команда',
    heading: 'Люди за продуктами',
    body: 'У каждого продукта своя небольшая команда, которая ведёт его от начала до конца.',
    founders: 'Основатели компании',
  },

  roles: {
    founder: 'Основатель',
    cofounder: 'Сооснователь',
    founderCeo: 'Основатель и CEO',
    ceo: 'CEO',
    cto: 'CTO',
    engineer: 'Разработчик',
    designer: 'Дизайнер',
    product: 'Продакт-менеджер',
    marketing: 'Маркетинг',
    content: 'Контент',
    operations: 'Операции',
  },

  principles: {
    eyebrow: 'О нас',
    heading: 'Как мы работаем',
    items: [
      {
        title: 'Продукт, который открывают каждый день',
        body: 'Мы создаём продукты, которые становятся привычкой, а не разовым решением.',
      },
      {
        title: 'Локальный контекст',
        body: 'Наши продукты рождаются из реальной потребности в Узбекистане и говорят по-узбекски.',
      },
      {
        title: 'Небольшая команда, быстрый запуск',
        body: 'Не длинные планы — мы раньше выпускаем рабочую версию и учимся у тех, кто ею пользуется.',
      },
    ],
  },

  contact: {
    heading: 'Сотрудничество или вопрос?',
    body: 'Пишите команде напрямую — мы читаем каждое письмо.',
  },

  footer: {
    tagline: 'Vaqtly Holding — компания, создающая цифровые продукты.',
    products: 'Продукты',
    contact: 'Контакты',
    about: 'О нас',
    rights: 'Все права защищены.',
  },

  product: {
    'russian-gg': {
      tagline: 'Говорите по-русски за 90 дней.',
      description:
        'Языковая платформа с упором на разговор. 15–20 минут голосовой практики в день — ' +
        'в реальных рабочих и бытовых ситуациях, с поддержкой на узбекском.',
    },
    sevil: {
      tagline: 'AI-стилист в кармане.',
      description:
        'Персональный стилист на основе искусственного интеллекта. Советы по стилю на ' +
        'узбекском языке, прямо с телефона.',
    },
  },
};

export default ru;
